import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGoogleLogin } from 'react-use-googlelogin';
import CookieConsent from 'react-cookie-consent';
import $ from 'jquery';
import { Avatar, Button, Col, Layout, Popover, Row, Select, Space, Tooltip } from 'antd';
import { setPmState } from '../store/entities/pm';
import InputBarPage from '../containers/InputBar/InputBarPage';
import MapPage from '../containers/MapPage';
import HeatmapPage from '../containers/Heatmap/HeatmapPage';
// import useHotkeys from "react-use-hotkeys";
import { useHotkeys } from 'react-hotkeys-hook';
import SettingsModal from '../containers/SettingsModal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/free-solid-svg-icons';
import PenetrationTable from '../containers/PM/PenetrationTable';
import { IS_DEV_VERSION, USE_DARK_MODE } from '../util/constants';

const clientId = '607020806390-1lvs93fvcei6ntf06gcsdsbrl415t5v9.apps.googleusercontent.com';
const {
  Header,
  Content
} = Layout;
const { Option } = Select;
const dashboardsBackendUrl = 'https://dashboards-backend-ootgoxvrsq-uc.a.run.app/';
let authRetryCount = 0;

const PmApp = (props) => {
  const dispatch = useDispatch();
  //Store variables
  const organizationName = useSelector(state => state.entities.pm.organizationName);
  const userEmail = useSelector(state => state.entities.pm.userEmail);
  //Local state
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [avatarPopoverVisible, setAvatarPopoverVisible] = useState(false);
  const [availableOrganizations, setAvailableOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(localStorage.getItem(
    'preferredOrganization'));
  const [penetrationTableVisible, setPenetrationTableVisible] = useState(false);
  // Initiate the Google login module - test commit for CI/CD after GitHub Enterprise upgrade by Purdue IT - 10/7/2026
  // This is a great example of object destructuring as well as object literals (clientId) (both of which are fun ES6 tricks)
  const {
    signIn,
    signOut,
    googleUser,
    isSignedIn,
    isInitialized
  } = useGoogleLogin({
    clientId,
    persist: true,
    cookiePolicy: 'none'
  });

  // Make the title 'DEV ...' if it is
  if (IS_DEV_VERSION) {
    document.title = 'DEV PM Heatmap';
  } else {
    document.title = 'PM Heatmap';
  }

  useEffect(() => isInitialized && authenticate(),
    [isSignedIn, isInitialized, selectedOrganization]);
  useEffect(() => {
    if (organizationName && organizationName !== 'Default') {
    }
  }, [organizationName]);
  const handleSignIn = async () => await signIn();
  /**
   * Get the available organizations for a user. Used to populate the dropdown.
   * Calls setAvailable organizations
   * @param sessionId The session ID to use
   */
  const getAvailableOrganizations = sessionId => {
    // If they have a sessionId and an email
    // How I'd like to do this is:
    //      'profileObj' in googleUser
    // However, if googleUser is null/undefined, it throws an error b/c 'in' expects an object.
    if (sessionId && googleUser && googleUser.profileObj) {
      $.ajax(`${dashboardsBackendUrl}user/organization/${googleUser.profileObj.email}`, {
          method: 'GET',
          beforeSend: xhr => xhr.setRequestHeader('Authorization', `Bearer ${sessionId}`),
          success: setAvailableOrganizations,
          // error: err => toast.error("Error getting organizations!")
          error: err => alert('Error getting organizations!')
        }
      );
    }
  };

  const authenticate = () => {
    /**
     * With current behavior, it will chose the organization in which the user has the highest privilege,
     * Only request login to specific organization if they've specified, otherwise, let the backend chose
     * and chose alphabetically from there
     */
    // let orgToSend = ""
    // if(isSignedIn && selectedOrganization !== "Default") orgToSend = selectedOrganization;
    // else if((!isSignedIn) && selectedOrganization) orgToSend =  selectedOrganization;
    $.ajax(`${dashboardsBackendUrl}authenticate/${selectedOrganization || ''}`, {
      method: 'GET',
      beforeSend: xhr => {
        if (isSignedIn) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + googleUser.tokenId);
        }
      },
      success: data => {
        // If they aren't logged into the default org, set their selected org
        // if (data['organization_name'] !== 'Default') setSelectedOrganization(data['organization_name']);
        // setSelectedOrganization(data['organization_name']);
        if (data.organization_name !== 'Default') setSelectedOrganization(data.organization_name);
        // Set the session ID, role, and org name, in addition to email if it exists.
        sessionStorage.setItem('sessionId', data.session_id);
        dispatch(setPmState({
          sessionId: data.session_id,
          role: data.role,
          organizationName: data.organization_name,
          mapCenter: data.map_center,
          mapZoom: data.map_zoom,
          /**
           * ..(condition && {objKey: objValue}) will only include objKey in the object IF condition is true.
           * ... is the spread operator. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_syntax
           * && conditionally invokes short-circuit evaluation.
           * This combo only asks the spread operator to spread {obj: objValue} IF the first condition evaluates to true.
           * You can do this with arrays too! https://amberley.dev/blog/2020-09-07-conditionally-add-to-array-or-obj/
           */
          ...((!!googleUser && !!googleUser.profileObj) && { userEmail: googleUser.profileObj.email })
        }));

        // The reason we have to pass the session ID is because the store will take a bit to reflect the changes, and I don't want to wait.
        // Pull the user's available organizations so they can switch
        getAvailableOrganizations(data.session_id);
        // Load the heatmap
        // loadHeatmap(data['session_id']);
      },
      error: err => {
        // The user doesn't belong to the organization
        if (err.status === 403 && err.responseText === 'User doesn\'t belong to that organization!') {
          // Reset the organization
          setSelectedOrganization('');
          localStorage.removeItem('preferredOrganization');
          // Make the request again
          // By doing ++ at the end, it will return the current value of authRetryCount, then increment the variable
          if (authRetryCount++ < 1) authenticate();
        }
        // Debug
        // eslint-disable-next-line no-console
        console.log(err);
      }
    });
  };

  useHotkeys('p', () => {
    setPenetrationTableVisible(prevState => !prevState);
  });

  return (
    <>
      <Layout className="layout">
        <Header style={{
          paddingLeft: '16px',
          paddingRight: '8px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            height: '64px'
          }}>
            <h1 style={{
              color: '#fff',
              flexGrow: 1,
              fontSize: '2.5em',
              paddingTop: '8px'
            }}>
              {IS_DEV_VERSION
                ? 'DEV PM Heatmap' : 'PM Heatmap'}
            </h1>
            <Space>
              <Popover
                content={(
                  <div>
                    <div>'<b>d</b>' - Download/Export Data</div>
                    <div>'<b>p</b>' - Penetration Table</div>
                  </div>
                )}
                title="Keyboard Shortcuts"
              >
                <Button icon={<FontAwesomeIcon icon={faKeyboard}/>}/>
              </Popover>

              {/* Add the SettingsModal, which includes the button */}
              <Tooltip title="Settings">
                <SettingsModal/>
              </Tooltip>
              {!isSignedIn && (
                <div>
                  <Button onClick={() => handleSignIn()} style={{ marginTop: '6px' }}>
                    Sign in
                  </Button>
                </div>
              )}
              {isSignedIn && (
                <div>
                  <Popover
                    placement="bottomRight"
                    trigger="click"
                    title={userEmail}
                    visible={avatarPopoverVisible}
                    onVisibleChange={setAvatarPopoverVisible}
                    content={
                      <Space direction="vertical">
                        <Select
                          style={{ width: '200px' }}
                          value={selectedOrganization}
                          onChange={value => {
                            setSelectedOrganization(value);
                            // Remember which org the user wants to login to
                            localStorage.setItem('preferredOrganization', value);
                          }}
                        >
                          {/* Add an option for each available organization */}
                          {availableOrganizations.map((org) => (
                            <Option key={org.organization_name}
                                    value={org.organization_name}>
                              {`${org.organization_name} | ${org.role_name}`}
                            </Option>
                          ))})
                        </Select>
                        <a
                          href="mailto:desaij@purdue.edu?cc=cgartne@purdue.edu&subject=PM%20Heatmap%3A%20New%20User%20Request&body=Please%20fill%20out%20the%20form%20below:%0D%0A%0D%0AGmail%20address%3A%0D%0AFirst%20name%3A%0D%0ALast%20name%3A%0D%0AOrganization%3A%0D%0A%0D%0ANotes%20(optional)%3A%0D%0A%0D%0A">Join
                          your organization</a>

                        <Button danger onClick={() => {
                          signOut()
                          .then(() => {
                            localStorage.removeItem('preferredOrganization');
                            setSelectedOrganization('');
                            authRetryCount = 0;
                          });
                        }}>Sign Out</Button>
                      </Space>
                    }
                  >
                    <Avatar
                      style={{
                        cursor: 'pointer',
                        position: 'relative',
                        right: '0',
                        backgroundColor: '#000',
                        marginBottom: '4px'
                      }}
                      src={googleUser.profileObj.imageUrl}
                      size={48}
                    >
                      {(avatarUrl) ? '' : 'Login'}
                    </Avatar>
                  </Popover>
                </div>
              )
              }
            </Space>
          </div>
        </Header>
      </Layout>
      <Row style={{
        width: '100%',
        height: '100%'
      }}>
        <Col span={18} style={{ padding: '1em' }}>
          <Content style={{ height: '100%' }}>
            <HeatmapPage/>
          </Content>
        </Col>
        <Col span={6} style={{
          padding: '1em',
          justifyContent: 'space-between',
          height: 'calc(100vh - 6em)'
        }}>
          <Content>
            <InputBarPage/>
          </Content>
          <Content
            style={{
              padding: '1em 0px',
              height: penetrationTableVisible ? 'calc(100% - 40em)' : 'calc(100% - 1em)'
            }}>
            <MapPage style={{
              border: `1px solid ${USE_DARK_MODE ? 'rgb(67, 67, 67)' : 'rgb(217, 217, 217)'}`,
              borderRadius: '2px'
            }}/>
          </Content>
          {penetrationTableVisible &&
          <Content style={{ height: '40em' }}>
            <PenetrationTable/>
          </Content>
          }
        </Col>
      </Row>
      {/*<Modal visible={penetrationTableVisible}*/}
      {/*       title={"Penetration"}*/}
      {/*       footer={null}*/}
      {/*       onOk={() => setPenetrationTableVisible(false)}*/}
      {/*       onCancel={() => setPenetrationTableVisible(false)}>*/}
      {/*</Modal>*/}
      <CookieConsent>This website uses cookies to keep you logged in.</CookieConsent>
      <ToastContainer position="bottom-right" autoClose={2000} closeOnClick={true}
                      pauseOnHover={true}/>
    </>
  );
};
export default PmApp;
